export default {
  detail: () => ['get', '/api/profile/detail'],
  updatePhoto: () => ['put', '/api/profile/photo'],
  updateFirebaseToken: () => ['put', '/api/profile/token'],
  updateFirebaseTokenByUserId: (userId) => [
    'put',
    `/api/profile/${userId}/token`,
  ],
};
